module.exports = __webpack_public_path__ + "2b9e7f2335822799516c2133d7126eca.svg";